import {SupportedLocales} from '#types/locale.js';

export const userMenuLocale = {
  [SupportedLocales.EN]: {
    menu: 'Account menu',
    profile: 'Profile',
    organization: 'Organization',
    admin: 'Admin',
    debug: 'Debug',
    logout: 'Logout',
  },
  [SupportedLocales.ES]: {
    menu: 'Menú de cuenta',
    profile: 'Perfil',
    organization: 'Organización',
    admin: 'Administrador',
    debug: 'Depurar',
    logout: 'Cerrar sesión',
  },
};
